import React, { useEffect } from 'react'

import { ChakraProvider, theme } from '@chakra-ui/react'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider, useDispatch, useSelector } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from 'redux-persist'
import store from './store'
import RenderRoutes from './routes/RenderRoutes'
import { logoutUser } from './store/slices/auth'

const persistor = persistStore(store)

const TokenExpirationChecker = () => {
  const dispatch = useDispatch()
  const { loginTime, isAuthenticated } = useSelector((state) => state.auth)

  useEffect(() => {
    const checkExpiration = () => {
      if (isAuthenticated) {
        if (!loginTime) {
          dispatch(logoutUser())
        } else {
          const now = Date.now()
          const sixteenHours = 16 * 60 * 60 * 1000
          if (now - loginTime > sixteenHours) {
            dispatch(logoutUser())
          }
        }
      }
    }

    // Check immediately
    checkExpiration()

    // Check every hour
    const interval = setInterval(checkExpiration, 60 * 60 * 1000) // 1 hour

    return () => clearInterval(interval)
  }, [isAuthenticated, loginTime, dispatch])

  return null
}

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <TokenExpirationChecker />
        <ChakraProvider theme={theme}>
          <Router>
            <RenderRoutes style={{ zIndex: 1000 }} />
          </Router>
        </ChakraProvider>
      </PersistGate>
    </Provider>
  )
}

export default App
